import { Routes } from '@angular/router';
import { AuthGuard } from '../services/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'Login',
    loadComponent: () => import('../routes/login/login.component').then(m => m.LoginComponent),
    data: { subtitle: 'Login' }
  },
  {
    path: 'Home',
    loadComponent: () => import('../routes/home/home.component').then(m => m.HomeComponent),
    canActivate: [AuthGuard],
    data: { subtitle: 'Home' }
  },
  {
    path: 'Home/:department',
    loadComponent: () => import('../routes/home/home.component').then(m => m.HomeComponent),
    canActivate: [AuthGuard],
    data: { subtitle: 'Home' }
  },
  {
    path: 'department/:department',
    loadComponent: () => import('../routes/department/department.component').then(m => m.DepartmentComponent),
    canActivate: [AuthGuard],
    data: { subtitle: 'Departamento' }
  },
  {
    path: 'Gob/PaP',
    loadComponent: () => import('../routes/gobierno/pap/pap.component').then(m => m.PaPComponent),
    canActivate: [AuthGuard],
    data: { subtitle: 'PaP'}
  },
  {
    path: 'Gob/Jiras',
    loadComponent: () => import('../routes/gobierno/jiras/jiras.component').then(m => m.JirasComponent),
    canActivate: [AuthGuard],
    data: { subtitle: 'Jiras' }
  },
  {
    path: 'Gob/CAB',
    loadComponent: () => import('../routes/gobierno/cab/cab.component').then(m => m.CabComponent),
    canActivate: [AuthGuard],
    data: { subtitle: 'CAB', requiredGroups: ['grpGeddisGob'] }
  },
  {
    path:'Serv/Backlog',
    loadComponent:() => import('../routes/servicio/backlog/backlog.component').then(m => m.BacklogComponent),
    canActivate:[AuthGuard],
    data: { subtitle:'Backlog'}
  },
  {
    path:'Serv/ComunicadoCAU',
    loadComponent:() => import('../routes/servicio/comunicado-cau/comunicado-cau.component').then(m => m.ComunicadoCAUComponent),
    canActivate:[AuthGuard],
    data: { subtitle:'Comunicado CAU'}
  }, 
  {
  path:'Gob/PMC',
  loadComponent:() => import('../routes/gobierno/PMC/PMC.component').then(m => m.PMCComponent),
  canActivate:[AuthGuard],
  data: { subtitle:'Project Management Core'}
  },
  {
  path:'Infra/Sentinel',
  loadComponent:() => import('../routes/infraestructura/sentinel/sentinel.component').then(m => m.SentinelComponent),
  canActivate:[AuthGuard],
  data: { subtitle:'Sentinel'}
  },
  {
    path:'Infra/FinOps',
    loadComponent:() => import ('../routes/infraestructura/fin-ops/fin-ops.component').then(m => m.FinOpsComponent),
    canActivate:[AuthGuard],
    data: { subtitle:'FinOps'}
  },
  {
    path: 'Serv/CalculadoraCAU',
    loadComponent: () => import('../routes/servicio/calculadora-cau/calculadora-cau.component').then(m => m.CalculadoraCAUComponent),
    canActivate: [AuthGuard],
    data: { subtitle: 'Calculadora CAU' }
  },
/*   {
    path: 'Serv/PSE',
    loadComponent: () => import('../routes/servicio/pse/pse.component').then(m => m.PSSComponent),
    canActivate: [AuthGuard],
    data: { subtitle: 'PSE' }
  }, */
  {
    path: '404',
    loadComponent: () => import('../routes/404/404.component').then(m => m.ErrorComponent),
    canActivate: [AuthGuard],
    data: { subtitle: '404 Not Found' }
  },
  {
    path: '**',
    loadComponent: () => import('../routes/404/404.component').then(m => m.ErrorComponent),
    canActivate: [AuthGuard],
    data: { subtitle: '404 Not Found' }
  },
  { path: '', redirectTo: 'Login', pathMatch: 'full' }
];
